import { render } from "./WorkView.vue?vue&type=template&id=d64ce20c&scoped=true&lang=pug"
import script from "./WorkView.vue?vue&type=script&lang=js"
export * from "./WorkView.vue?vue&type=script&lang=js"

import "./WorkView.vue?vue&type=style&index=0&id=d64ce20c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d64ce20c"]])

export default __exports__